import Vue from 'vue'
import VueMask from 'v-mask'
import jwt_decode from 'jwt-decode'
import Swal from 'sweetalert2'
import config from '../../../static/config.json'
import api from '../../models/services'
const numeral = require('numeral')
const moment = require('moment')
const ThaiBaht = require('thai-baht-text')
Vue.use(VueMask)

Vue.mixin({
  data() {
    return {
      header: {
        headers: {
          Authorization: `Bearer ${sessionStorage.token}`
        }
      },
      title_web: config.title_web,
      description_web: config.description_web
    }
  },
  methods: {
    checkOAuth() {
      if (localStorage.token !== undefined || sessionStorage.token !== undefined) {
        const token = sessionStorage.token
        this.checkToken(token)
      } else {
        if (localStorage.refresh_token) {
          this.OAuthToken()
        } else {
          localStorage.clear()
          sessionStorage.clear()
          this.$store.state.user = undefined
          this.$router.push('/login')
        }
      }
    },
    async checkToken(token) {
      try {
        const jwt = jwt_decode(token)
        if (jwt !== null) {
          const TimoOutLogin = this.daysDiff(this.dateFormatFullTime(new Date()), jwt.expire)
          if (parseInt(TimoOutLogin) <= 0) {
            await this.OAuthToken()
          } else {
            await this.checkPermission(jwt.role_id)
          }
        } else {
          this.OAuthToken()
        }
      } catch (e) {
        console.log(e)
      }
    },
    async OAuthToken() {
      if (this.$route.path !== 'login' && this.$route.path !== '/404') {
        var obj = {
          refresh_token: localStorage.refresh_token
        }
        await api.OAuth(
          this.$store.state.URLHost,
          obj,
          result => {
            if (result.response === true) {
              sessionStorage.token = result.data.access_token
              this.header = {
                headers: {
                  Authorization: `Bearer ${sessionStorage.token}`
                }
              }
              setTimeout(() => {
                this.checkToken(sessionStorage.token)
              }, 500)
            } else {
              $('.preloader').fadeOut()
              Swal.fire({
                title: result.message,
                text: 'You have logged in more than the specified time',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#F43131',
                confirmButtonText: 'Logout',
                cancelButtonText: 'Again',
                reverseButtons: true,
                customClass: 'Custom_Cancel'
              }).then(result => {
                if (result.isConfirmed) {
                  this.logOut()
                  return false
                } else {
                  this.OAuthToken()
                  return false
                }
              })
            }
          },
          error => {
            $('.preloader').fadeOut()
            if (error.message === 'Network Error') {
              this.alert_msg('error', 'Check', 'Unable to login because ' + JSON.stringify(error.message))
              localStorage.clear()
              sessionStorage.clear()
              this.$store.state.user = undefined
              this.$router.push('/login')
              // eslint-disable-next-line no-undef
              $('.preloader').fadeOut()
            } else {
              Swal.fire({
                title: error.message,
                text: 'There is a problem with your key, would you like to log out ?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#F43131',
                confirmButtonText: 'Logout',
                cancelButtonText: 'Again',
                reverseButtons: true,
                customClass: 'Custom_Cancel'
              }).then(result => {
                if (result.isConfirmed) {
                  this.logOut()
                } else {
                  this.OAuthToken()
                }
              })
            }
          }
        )
      }
    },
    alert_msg(type, title, text = null) {
      switch (type) {
        // eslint-disable-next-line no-undef
        case 'success':
          toastr.success(text, title, { progressBar: true, closeButton: true })
          break
        // eslint-disable-next-line no-undef
        case 'info':
          toastr.info(text, title, { progressBar: true, closeButton: true })
          break
        // eslint-disable-next-line no-undef
        case 'warning':
          toastr.warning(text, title, { progressBar: true, closeButton: true })
          break
        // eslint-disable-next-line no-undef
        case 'error':
          toastr.error(text, title, { progressBar: true, closeButton: true })
          break
      }
    },
    reload() {
      this.$store.state.isLoading = true
      location.reload()
    },
    ModalBoots(Id) {
      // eslint-disable-next-line no-undef
      return new bootstrap.Modal(document.getElementById(Id))
    },
    daysDiff(d1, d2) {
      const startDate = moment(d1).format('x')
      // Do your operations
      const endDate = moment(d2).format('x')
      const seconds = (endDate - startDate) / 60000
      return Math.floor(seconds)
    },
    getLastDate(Data) {
      const res = Data.split('-')
      const month = res[1] // January
      const year = res[0]
      const d = new Date(year, month, 0)
      return moment(d).format('DD')
    },
    dateYearThai(date) {
      return parseInt(moment(date).format('YYYY')) + 543
    },
    dateMonth(date) {
      return moment(date).format('YYYY-MM')
    },
    dateFormatAndTime(date) {
      moment.locale()
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
    dateFormatAndFulltime(date) {
      moment.locale()
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    dateFormatFullTime(date) {
      moment.locale()
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    dateConvertYMD(date) {
      const res = date.split('/')
      return res[2] + '-' + res[1] + '-' + res[0]
    },
    dateFormatDMY(date) {
      moment.locale()
      return moment(date).format('DD/MM/YYYY')
    },
    dateFormatDMY2(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    dateFormatYMD(date) {
      moment.locale()
      return moment(date).format('YYYY-MM-DD')
    },
    dateFormatDDMMYYYY(date) {
      moment.locale()
      return moment(date).format('DD-MM-YYYY')
    },
    dateFormatMY(date) {
      moment.locale()
      return moment(date).format('MM/YYYY')
    },
    dateFormatMil(date) {
      moment.locale()
      return moment(date).format()
    },
    dateFormatTime(date) {
      moment.locale()
      return moment(date).format('HH:mm')
    },
    monthFormat(str) {
      switch (str) {
        case '01':
          return 'ม.ค'
        case '02':
          return 'ก.พ'
        case '03':
          return 'มี.ค'
        case '04':
          return 'เม.ย'
        case '05':
          return 'พ.ค'
        case '06':
          return 'มิ.ย'
        case '07':
          return 'ก.ค'
        case '08':
          return 'ส.ค'
        case '09':
          return 'ก.ย'
        case '10':
          return 'ต.ค'
        case '11':
          return 'พ.ย'
        default:
          return 'ธ.ค'
      }
    },
    monthYearFormat(str) {
      const date = str.split('-')
      switch (date[1]) {
        case '01':
          return 'มกราคม ' + date[0]
        case '02':
          return 'กุมภาพันธ์ ' + date[0]
        case '03':
          return 'มีนาคม ' + date[0]
        case '04':
          return 'เมษายน ' + date[0]
        case '05':
          return 'พฤษภาคม ' + date[0]
        case '06':
          return 'มิถุนายน ' + date[0]
        case '07':
          return 'กรกฎาคม ' + date[0]
        case '08':
          return 'สิงหาคม ' + date[0]
        case '09':
          return 'กันยายน ' + date[0]
        case '10':
          return 'ตุลาคม ' + date[0]
        case '11':
          return 'พฤศจิกายน ' + date[0]
        default:
          return 'ธันวาคม ' + date[0]
      }
    },
    dateThaiFormat(str) {
      const date = str.split('-')
      switch (date[1]) {
        case '01':
          return date[2] + ' มกราคม ' + (date[0] + 543)
        case '02':
          return date[2] + ' กุมภาพันธ์ ' + (date[0] + 543)
        case '03':
          return date[2] + ' มีนาคม ' + (date[0] + 543)
        case '04':
          return date[2] + ' เมษายน ' + (date[0] + 543)
        case '05':
          return date[2] + ' พฤษภาคม ' + (date[0] + 543)
        case '06':
          return date[2] + ' มิถุนายน ' + (date[0] + 543)
        case '07':
          return date[2] + ' กรกฎาคม ' + (date[0] + 543)
        case '08':
          return date[2] + ' สิงหาคม ' + (date[0] + 543)
        case '09':
          return date[2] + ' กันยายน ' + (date[0] + 543)
        case '10':
          return date[2] + ' ตุลาคม ' + (date[0] + 543)
        case '11':
          return date[2] + ' พฤศจิกายน ' + (date[0] + 543)
        default:
          return date[2] + ' ธันวาคม ' + (date[0] + 543)
      }
    },
    numberFormatDecimal(str) {
      return numeral(str).format('0,0.00')
    },
    numberFormat(str) {
      return numeral(str).format('0,0')
    },
    moneyText(str) {
      return ThaiBaht(str)
    },
    convert_vs(val) {
      const data = []
      let len = 3
      if (val.length > 3) {
        len = val.length
      }
      let vallen = val.length
      for (let i = 0; i < len; i++) {
        const v = val.split('')
        if (len - i === vallen) {
          const ss = len - i
          if (ss === vallen) {
            if (val.length === 1) {
              data.push(val)
            } else if (len > val.length) {
              data.push(v[i - 1])
            } else {
              data.push(v[i])
            }
          } else {
            data.push(v[i - 1])
          }
          vallen--
        } else {
          data.push('0')
        }
      }
      let versions = ''
      for (let l = 0; l < data.length; l++) {
        versions += data[l]
        if (l < data.length - 1) {
          versions += '.'
        }
      }
      return versions
    },
    DataURIToBlob(dataURI) {
      const binary = atob(dataURI.split(',')[1])
      const array = []
      for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i))
      }
      return new Blob([new Uint8Array(array)], { type: 'image/jpeg' })
    },
    playSound(sound) {
      if (sound) {
        const audio = new Audio(sound)
        audio.play()
      }
    },
    toDo() {
      this.alert_msg('warning', 'To Do', 'Develop is process')
    },
    getProfile() {
      $('.preloader').fadeOut()
      this.$store.state.isLoading = true
      api.getProfile(
        this.$store.state.URLHost,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.token}`
          }
        },
        result => {
          if (result.response === true) {
            this.$store.state.user = result.data
            this.$store.state.isLoading = false
            // eslint-disable-next-line no-undef
            $('.preloader').fadeOut()
          } else {
            this.getProfile()
          }
        },
        error => {
          this.alert_msg('error', 'Get Profile', 'Unable to retrieve user information because ' + error.message)
          this.OAuthToken()
        }
      )
    },
    checkPermission(roleId) {
      // if (this.$route.meta.menu_id === 0) {
      //   window.location.href = '/'
      // }
      this.$store.state.isLoading = true
      api.checkPermiss(
        this.$store.state.URLHost,
        this.$route.meta.menu_id,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.token}`
          }
        },
        async result => {
          if (result.response === true) {
            await this.getProfile()
            if (result.data === false) {
              this.defaultRoute(roleId)
            } else {
              this.$store.state.isLoading = false
            }
          } else {
            this.alert_msg('warning', 'Check Permission', result.message)
            await this.OAuthToken()
          }
        },
        error => {
          this.alert_msg('error', 'Check Permission', error.message)
          this.$router.push('/404')
        }
      )
    },
    defaultRoute(roleId) {
      api.getPermission(
        this.$store.state.URLHost,
        roleId,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.token}`
          }
        },
        result => {
          if (result.response === true) {
            $('.preloader').fadeOut()
            try {
              result.data.forEach(v => {
                if (parseInt(v.is_active) === 1) {
                  // this.alert_msg('warning', 'ตรวจสอบข้อมูล', 'คุณไม่มีสิทธิ์เข้าหน้านี้')
                  this.$router.push(v.path)
                  // eslint-disable-next-line no-undef
                  throw BreakException
                }
              })
            } catch (e) {
              // this.alert_msg('warning', 'ตรวจสอบข้อมูล', 'คุณไม่มีสิทธิ์เข้าหน้านี้')
              // eslint-disable-next-line no-console
              console.log(e)
            }
          }
        },
        error => {
          this.alert_msg('error', 'Check Permission', error.message)
          // this.$router.push('/404')
        }
      )
    },
    logOut() {
      $('.preloader').fadeIn()
      var obj = {
        refresh_token: localStorage.refresh_token
      }
      api.Revoke(
        this.$store.state.URLHost,
        obj,
        result => {
          if (result.response === true) {
            localStorage.clear()
            sessionStorage.clear()
            this.$store.state.user = undefined
            window.location.replace('/login')
            $('.preloader').fadeOut()
          } else {
            this.alert_msg('warning', 'Logout', result.message)
            localStorage.clear()
            sessionStorage.clear()
            this.$store.state.user = undefined
            window.location.replace('/login')
            $('.preloader').fadeOut()
          }
        },
        error => {
          if (error.message === 'Network Error') {
            this.alert_msg('error', 'Logout', 'Unable to login because ' + JSON.stringify(error.message))
            localStorage.clear()
            sessionStorage.clear()
            this.$store.state.user = undefined
            this.$router.push('/login')
            $('.preloader').fadeOut()
          } else {
            localStorage.clear()
            sessionStorage.clear()
            this.$store.state.user = undefined
            window.location.replace('/login')
            $('.preloader').fadeOut()
          }
        }
      )
    },
    dateTimeFormat(date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
    timeFormatHHMM(datetime) {
      return moment(datetime).format('HH:mm')
    }
  }
})



// WEBPACK FOOTER //
// ./src/assets/js/mixin.js